import { registerSectionType } from "../../utils/sectionRegistry";
import { renderImage } from "../sectionHelpers";

registerSectionType({
  type: "division",
  label: "Division",
  layout: "split",
  previewBlocks: ["Texto", "Imagen"],
  legacyType: "split",
  render: (section, index) => {
    const reverseClass = section?.reverse ? "dynamic-split-reverse" : "";
    return (
      <section key={`split-${index}`} className={`dynamic-section dynamic-split ${reverseClass}`}>
        <div className="dynamic-split-content">
          {section?.title ? <h2>{section.title}</h2> : null}
          {section?.description ? <p className="dynamic-description">{section.description}</p> : null}
        </div>
        {section?.image?.src ? (
          <div className="dynamic-split-media">
            {renderImage(section.image.src, section.image.alt || section.title || "Imagen")}
          </div>
        ) : null}
      </section>
    );
  },
});
